import { ActionReducerMap } from '@ngrx/store';
import { PreApplicationState } from '../models/state/pre-application.model';
import { preApplicationReducer } from './reducers/pre-application.reducer';
import { declinedMessageReducer } from './reducers/declined-message.reducer';
import { RoutingState } from '../models/state/routing-state.model';
import { routingReducer } from './reducers/routing.reducer';
import { DeclinedState } from '../models/state/declined-state.model';
import { onboardingProcessReducer } from './reducers/onboarding-process.reducer';
import { OnboardingProcessState } from '../models/state/onboarding-process-state.model';
import { AppSettingsState } from '../models/state/app-settings-state.model';
import { appSettingsReducer } from './reducers/app-settings.reducer';
import { TdcApplicationState } from '../models/state/tdc-application-state.model';
import { tdcApplicationReducer } from './reducers/tdc-application.reducer';
import { PreauthorizedOffer } from '../models/state/preauthorized-offer.model';
import { preauthorizedOfferReducer } from './reducers/preauthorized-offer.reducer';

export interface AppState {
	preApplication: PreApplicationState;
	declinedMessage: DeclinedState;
	routing: RoutingState;
	onboardingProcess: OnboardingProcessState;
	appSettings: AppSettingsState;
	tdcApplication: TdcApplicationState;
	preauthorizedOffer: PreauthorizedOffer;
}

export const ROOT_REDUCERS: ActionReducerMap<AppState> = {
	preApplication: preApplicationReducer,
	declinedMessage: declinedMessageReducer,
	routing: routingReducer,
	onboardingProcess: onboardingProcessReducer,
	appSettings: appSettingsReducer,
	tdcApplication: tdcApplicationReducer,
	preauthorizedOffer: preauthorizedOfferReducer,
};
